import React, { useEffect } from "react";
// import { Route, Switch, useLocation } from "react-router-dom";
// import { useTransition, animated } from "react-spring";
import { connect } from "react-redux";
import Layout from "./Shared/Pages/Layout/Layout.page";
import AppGuardia from "./App.guard";
import PrivateRoute from "./Shared/Routes/Private.route";
import PublicRoute from "./Shared/Routes/Public.route";
import * as loginActions from "./Core/Actions/Login.actions";
import "./App.scss";

const App = ({ loginReducer, consumirAutoLogin }) => {
  // const location = useLocation();
  // const transicion = useTransition(location, (location) => location.pathname, {
  //   from: { opacity: 0, transform: "translate(100%, 0)" },
  //   enter: { opacity: 1, transform: "translate(0%, 0)" },
  //   leave: { opacity: -1, transform: "translate(-50%, 0)" },
  // });

  useEffect(() => {
    const clienteStorageStr = localStorage.getItem("clienteStorage") || "";
    const { hayCliente } = loginReducer;

    if (hayCliente === false && clienteStorageStr !== "") {
      consumirAutoLogin();
    }
  }, []);

  return (
    <Layout>
      <AppGuardia>
        {({ hayCliente }) =>
          hayCliente === true ? <PrivateRoute /> : <PublicRoute />
        }
      </AppGuardia>
    </Layout>
  );
};

const mapStateToProps = ({ loginReducer }) => {
  return { loginReducer };
};

const mapDispatchToProps = {
  ...loginActions,
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
